type SitAttribute = `sit${string}`;

export function isHtmlElement(target: EventTarget): target is HTMLElement {
  return target instanceof HTMLElement && target.nodeType === 1;
}

export function closestDataSitAttribute(
  composedPath: EventTarget[],
  sitAttribute: SitAttribute,
) {
  if (!composedPath) return undefined;
  for (const element of composedPath) {
    if (
      isHtmlElement(element) &&
      element.dataset &&
      element.dataset[sitAttribute]
    ) {
      return element.dataset[sitAttribute];
    }
  }
  return undefined;
}
